import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";

/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { TableActions } from 'components';
import { dateFormat, rolesTypesName } from 'enums';
import { detailsBtn, canApproveText } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var employeeListColumns = [{
  name: 'ID',
  render: function render(employee) {
    return ___EmotionJSX(Link, {
      to: {
        pathname: "employee/details/".concat(employee === null || employee === void 0 ? void 0 : employee.id),
        state: {
          employee: employee
        }
      }
    }, employee === null || employee === void 0 ? void 0 : employee.id);
  },
  width: '60px'
}, {
  name: 'Име',
  value: 'name'
}, {
  name: 'Телефон',
  value: 'phone'
}, {
  name: 'Имейл',
  value: 'email'
}, {
  name: 'Роля',
  render: function render(_ref) {
    var user_role = _ref.user_role;
    return ___EmotionJSX("span", null, rolesTypesName[user_role]);
  },
  width: '100px'
}, {
  name: 'Права за одобрение',
  render: function render(_ref2) {
    var can_approve = _ref2.can_approve;
    return ___EmotionJSX("span", {
      css: canApproveText(can_approve)
    }, can_approve ? 'ДА' : 'НЕ');
  },
  width: '100px'
}, {
  name: 'Създаден на',
  value: 'created_at',
  dateTimeFormat: dateFormat,
  width: '120px'
}, {
  name: '',
  render: function render(employee) {
    return ___EmotionJSX(TableActions, {
      mainAction: {
        linkTo: {
          pathname: "/employee/details/".concat(employee === null || employee === void 0 ? void 0 : employee.id),
          state: {
            employee: employee
          }
        },
        leftIcon: {
          iconName: 'la la-info',
          size: 20
        },
        css: detailsBtn
      }
    });
  },
  width: '50px'
}].filter(Boolean);